import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function ProteinSummaryFigure(props) {

    const { width, height, totalResidues, residueAnnotations } = props;

    return (
        <div>
            <svg version="1.1" baseProfile="full" width={width} height={height}
                xmlns="http://www.w3.org/2000/svg">

                <rect width={width} height={height} fill="#ffcc99" />

                {residueAnnotations.map((ann, index) => {
                    const x = width * ann.position / totalResidues;
                    return (
                        <line key={index} x1={x} y1={height} x2={x} y2={0} strokeWidth="2" stroke="#cc9966" />
                    );
                })}
            </svg>
        </div>
    );
}

ProteinSummaryFigure.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    totalResidues: PropTypes.number.isRequired,
    residueAnnotations: PropTypes.array,
}

ProteinSummaryFigure.defaultProps = {
    width: 150,
    height: 20,
}

export default ProteinSummaryFigure;